// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-q_fk","galleryItem_borderTopRadius":"c-q_fl","galleryItem__image":"c-q_fm"};